// src/Pages/Landing/JoyrideKeravaLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyrideKeravaLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Kerava"
      maakunta="Uusimaa"
      nearbyAreas={[
        "Järvenpää",
        "Tuusula",
        "Vantaa",
        "Sipoo",
        "Helsinki",
        "Espoo"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Keravalla ja lähialueilla tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Kerava sopii Bilebändi Joyridelle erityisen hyvin esimerkiksi häihin, syntymäpäiville, yritysjuhliin, pikkujouluihin ja yksityistilaisuuksiin, kun juhliin halutaan energinen livebändi."
      logisticsText="Bilebändi Joyride toimii Keski-Uudeltamaalta käsin, joten Kerava on bändille omaa lähialuetta. Oma kuljetus, oma äänentoisto ja valotekniikka helpottavat keikan toteutusta ja tekevät kokonaisuudesta selkeän myös tapahtumapaikoissa, joissa ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}